/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    betting_live_of_the_day: {
        defaultMessage: 'Live',
        id: 'component.PromoHeader.Live'
    },
    betting_match_of_the_day: {
        defaultMessage: 'Match',
        id: 'component.PromoHeader.Match'
    },
    betting_sport_event: {
        defaultMessage: 'Top Event',
        id: 'component.PromoHeader.TopEvent'
    },
    ofTheDay: {
        defaultMessage: 'of the day',
        id: 'component.PromoHeader.OfTheDay'
    }
})